import { useQuery } from "@tanstack/react-query";
import DashStatTile from "./v2/DashStatTile";
import { faUserTag } from "@fortawesome/free-solid-svg-icons";
import axios, { AxiosError } from "axios";
import { usePermissionModal } from "contexts/PermissionModalContext";
import { formatCurrency } from "utils/formatters";

interface VendedorDestaque {
  nome: string;
  valorVendas: number;
  quantidadeVendas: number;
}

const fetchVendedorDestaque = async (): Promise<VendedorDestaque> => {
  const response = await axios.get("/api/dashboardStats/vendedor-destaque");
  return response.data.data;
};

const VendedorDestaque = () => {
  const { getQueryRetryHandler } = usePermissionModal();

  const { data, isLoading, error } = useQuery<VendedorDestaque, AxiosError>({
    queryKey: ["vendedorDestaque"],
    queryFn: fetchVendedorDestaque,
    retry: getQueryRetryHandler({
      queryKey: ["vendedorDestaque"],
      defaultMessage: "Você não possui permissão para visualizar o vendedor destaque.",
      showModal: false,
    }),
  });

  const isAccessDenied = axios.isAxiosError(error) && error?.response?.status === 403;
  if (isAccessDenied) return null;

  const temVendedor = data && data.valorVendas > 0;

  return (
    <DashStatTile
      label="Vendedor Destaque"
      value={temVendedor ? data.nome : "Sem dados no período"}
      icon={faUserTag}
      variant="accent2"
      size="name"
      isLoading={isLoading}
      footnote={temVendedor ? `${formatCurrency(data.valorVendas)} em vendas` : undefined}
    />
  );
};

export default VendedorDestaque;
